// import { useMediaQuery, useTheme } from "@mui/material";
// import { Box } from "@mui/system";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
// import logo from "../../assets/eCarehealth-Logo.png";
// import Flex from "../../components/Flex";
// import RightCarousel from "../../components/auth/RightCarousel";
// import HelpSupport from "../../services/support/HelpSupport";

// v2 changes
import logo from "../../assets/eCarehealth-Logo.svg";
import SiteUnreachable from "../../pages/auth/SiteUnreachable";
import { useGetProivderGroupName } from "../../queries/use-get-provider-name";
import { getTenantFromHostname } from "../../utils/get-tenant-from-hostname";

const AuthLayout = () => {
  // const theme = useTheme();
  // const toDisplayRightCarousel = useMediaQuery(theme.breakpoints.up("lg"));
  const { pathname } = useLocation();
  const isLoginRoute = pathname.includes("/auth/login");
  const xTENANTID = getTenantFromHostname();

  const {
    data: ProviderGroupData,
    isError,
    isLoading,
    isFetched,
  } = useGetProivderGroupName({
    xTENANTID,
  });

  const groupName = (ProviderGroupData as any)?.data?.data?.name;
  // Admin portal has no xTENANTID (query disabled) — keep card visible there.

  const isGroupNotFound = isLoginRoute && !!xTENANTID && isError && isFetched;
  if (isLoading) return <></>;
  if (isGroupNotFound) return <SiteUnreachable />;

  return (
    // <Flex height={"100vh"} bgcolor={"white"}>
    //   <Flex
    //     width={"100%"}
    //     gap={"40px"}
    //     justifyContent={"center"}
    //     alignItems={"center"}
    //     position={"relative"}
    //   >
    //     <Box position="absolute" width={"224px"} top={26} left={24}>
    //       <img height={"46px"} src={logo} alt="Company-logo" />
    //     </Box>
    //     <Box p={2} width={"32.885rem"}>
    //       <Outlet />
    //     </Box>
    //   </Flex>
    //   <Box width={"100%"} display={toDisplayRightCarousel ? "unset" : "none"}>
    //     <RightCarousel />
    //   </Box>
    //   <HelpSupport />
    // </Flex>
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #E5F3FF 0%, #A0D1F8 100%)",
      }}
    >
      {/* V2 changes */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "464px",
          backgroundColor: "#fff",
          border: "1px solid #E7E7E7",
          borderRadius: "8px",
          boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.1)",
          p: "32px",
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          gap: "40px",
        }}
      >
        {/* Logo */}
        <Box>
          <img src={logo} alt="eCarehealth" height="60px" />
        </Box>

        <Outlet context={groupName} />
      </Box>
    </Box>
  );
};

export default AuthLayout;
